import React from 'react'
import { Link } from 'react-router-dom'
import {SlideshowLightbox} from 'lightbox.js-react'
const SubActivity = () => {
  return (
    <>
    <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1"><img src="/Images/page-header-shape-1.png" alt="Loreto Convent School, Delhi Cantt"/></div>
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> Recent Activity in School  </li>
                <li> Sub Activity    </li>
            </ul>
            <h2>Sub Activity   </h2>
        </div>
        </div>
    </section>
    <section className="innerbody">
    <div className="container">
       <div className="row">
          <div className="col-md-12"> 
     
             <div className="fulwidth">
                <div className="sub-gallery">
                   <div className="shrink"><Link to="/RecentActivity"><i className="bi bi-arrow-left"></i></Link></div>
                   <div><b>Event Date:</b> DD MM YYYY</div>
                   <div><b>Updated On:</b> DD MM YYYY</div>
                   <div><b>Total Photos:</b> 3</div>
                </div>
                <div className="discription">
                   <h3 className="subhead">Title</h3>
                   <p><b>Description:</b> Stay connected for more updates!</p>
                </div>
             </div>
             <div className="flexbox-v zoompic">
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
                <div>
                    <SlideshowLightbox><img src="/Images/gal-1.jpg" alt="Loreto Convent School Delhi Cantt" className="img-fluid"/></SlideshowLightbox>
                </div>
             </div>  
          </div>
       </div>
    </div>
    </section>
   </>
  )
}

export default SubActivity